import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Stay, AuthResponse } from '../types/stay';

const TOKEN_KEY = 'yoga-auth-token';

// Mock data
const mockStays: Stay[] = [
  {
    from_date: '2024-01-20',
    until_date: '2024-01-27',
    kind: 'Yoga Retreat',
  },
  {
    from_date: '2024-02-15',
    until_date: '2024-02-22',
    kind: 'Meditation Week',
  },
];

export const useStayStore = defineStore('stay', () => {
  const token = ref<string | null>(localStorage.getItem(TOKEN_KEY));
  const stays = ref<Stay[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const bookingNumber = ref('');
  const lastName = ref('');

  async function authenticate(
    _bookingNum: string,
    _lastN: string
  ): Promise<boolean> {
    try {
      isLoading.value = true;
      error.value = null;

      // Mock API call
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Mock successful authentication
      const mockResponse: AuthResponse = { token: 'mock-token-123' };

      token.value = mockResponse.token;
      localStorage.setItem(TOKEN_KEY, mockResponse.token);

      await fetchStays();
      return true;
    } catch (e) {
      error.value = 'Authentication failed';
      return false;
    } finally {
      isLoading.value = false;
    }
  }

  async function fetchStays() {
    try {
      isLoading.value = true;
      error.value = null;

      // Mock API call
      await new Promise((resolve) => setTimeout(resolve, 500));
      stays.value = mockStays;
    } catch (e) {
      error.value = 'Failed to fetch stays';
      console.error('Error fetching stays:', e);
    } finally {
      isLoading.value = false;
    }
  }

  function logout() {
    token.value = null;
    stays.value = [];
    bookingNumber.value = '';
    lastName.value = '';
    localStorage.removeItem(TOKEN_KEY);
  }

  return {
    token,
    stays,
    isLoading,
    error,
    bookingNumber,
    lastName,
    authenticate,
    fetchStays,
    logout,
  };
});
